import React, { useState, useEffect } from "react";
import { show02 } from "../assets";
import { GiRotaryPhone } from "react-icons/gi";
import { IoIosMail } from "react-icons/io";
import Followme from "./banners/Followme";
import { RiMailSendLine } from "react-icons/ri";
import { FaHome } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Pageme = () => {
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const [verNum, setVerNum] = useState(0);
  const [placeholderVer, setplaceholderVer] = useState(
    "Enter the number above"
  );
  const [inputMatch, setInputMatch] = useState("");
  const [isValidated, setIsValidated] = useState(false);

  const createVerNum = () => {
    const num = Math.round((Math.random() + Number.EPSILON) * 10000);
    setVerNum(num);
  };

  useEffect(() => {
    createVerNum();
  }, []);

  const matchUp = (e) => {
    e.preventDefault();
    if (parseInt(verNum) === parseInt(inputMatch)) {
      setIsValidated(true);
    } else {
      setplaceholderVer("Don't match, try again.");
      setInputMatch("");
      setIsValidated(false);
    }
    console.log({ placeholderVer });
  };

  const emailValidation = () => {
    return String(email)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };

  const handleSend = (e) => {
    e.preventDefault();
    if (username === "") {
      setErrMsg("Username is required");
      console.log(errMsg);
    } else if (email === "") {
      setErrMsg("email is required");
      console.log(errMsg);
    } else if (!emailValidation(email)) {
      setErrMsg("provide a valid email");
      console.log(errMsg);
    } else if (subject === "") {
      setErrMsg("subject is required");
      console.log(errMsg);
    } else if (message === "") {
      setErrMsg("message is required");
      console.log(errMsg);
    } else {
      try {
        const values = {
          name: username,
          phoneNumber: phoneNumber ? phoneNumber : "phone number not provided ",
          email: email,
          subject: subject,
          message: message,
        };
        console.log(values);
        emailjs
          .send(
            process.env.REACT_APP_SERVICE_ID,
            process.env.REACT_APP_TEMPLATE_ID,
            values,
            process.env.REACT_APP_PUBLIC_KEY
          )
          .then((response) => {
            setSuccessMsg(
              "Your message was sent successfully, Phil will be happy to read it and will be back to you very soon."
            );
            setErrMsg("");
            setUsername("");
            setPhoneNumber("");
            setEmail("");
            setSubject("");
            setMessage("");
            console.log(username, phoneNumber, email, subject, message);
          });
      } catch (error) {
        setErrMsg(error.message);
      } finally {
        setIsValidated(false);
        setInputMatch();
      }
    }
  };

  return (
    <section id="pageme" className="w-full h-auto px-16 pt-20 pb-10 lg:px-4">
      <div className="flex w-[100%] ">
        <div className="w-full pb-5">
          <div className="pb-10 text-center">
            <h2 className="text-5xl font-FreckleFace capitalize pb-2">
              Enough stalkings!
            </h2>
            <h3 className="text-xl">
              Page Me! Let's connect and talk. Phil is coming to rescue.
            </h3>
          </div>
          <div className="flex w-full h-auto md:flex-col justify-between">
            <div
              className="w-[30%] md:w-[100%] h-full bg-black
             p-8 rounded-2xl shadow-lg border-2 border-solid border-stone-700 shadow-slate-600 flex flex-col 2xl:pb-16 lg:pb-1 md:flex-row md:gap-16"
            >
              <div>
                <img
                  className="w-full h-auto object-cover lg:object-left-top lg:object-none rounded-lg mb-5 sm:opacity-0"
                  src={show02}
                  alt="phil02"
                />
              </div>
              <div className="flex flex-col gap-2 sm:left-20 sm:absolute">
                <h3 className="text-5xl font-bold font-FreckleFace text-white">
                  Philip Page
                </h3>
                <p className=" text-gray-400 text-3xl flex items-center gap-1">
                  <GiRotaryPhone />
                  <span className="text-white flex text-xl">*upon request</span>
                </p>
                <p className=" text-gray-400 text-3xl flex items-center gap-1">
                  <FaHome />
                  <span className="text-white flex text-xl">
                    Washington, DC
                  </span>
                </p>
                <p className=" text-gray-400 text-3xl flex items-center gap-1">
                  <IoIosMail />
                  <span className="text-white flex text-xl">
                    loginpagecomedy@gmail.com
                  </span>
                </p>
                <div className=" text-white justify-center text-2xl xl:text-xl flex items-center gap-1 xl:mb-24 lg:mb-56 md:mb-20">
                  <Followme />
                </div>
              </div>
            </div>
            <div
              className="w-[65%] md:w-[100%] h-full bg-black
             p-8 rounded-2xl shadow-lg border-2 border-solid border-stone-700 shadow-slate-600 flex flex-col md:mt-8"
            >
              <form className="w-full flex flex-col gap-6 py-16 2xl:py-1 lg:py-2">
                <div className="w-full flex gap-10 sm:flex-col">
                  <div className="w-1/2 flex flex-col gap-4 sm:w-full sm:flex-none">
                    <input
                      id="name"
                      onChange={(e) => setUsername(e.target.value)}
                      value={username}
                      type="text"
                      placeholder=" &#x263B; Your Name"
                      className={`${
                        errMsg === "Username is required" && "bg-red-600"
                      } bg-neutral-700 rounded-md h-10 text-2xl`}
                    />
                  </div>
                  <div className="w-1/2 flex flex-col gap-4 sm:w-full sm:flex-none">
                    <input
                      id="phoneNumber"
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      value={phoneNumber}
                      type="text"
                      placeholder=" &#x260E; Phone (optional)"
                      className="bg-neutral-700 rounded-md h-10 text-2xl"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-10">
                  <input
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    type="email"
                    placeholder=" &#x2709; Your Email"
                    className={`${
                      errMsg === "email is required" && "bg-red-600"
                    } ${
                      errMsg === "provide a valid email" && "bg-red-600"
                    } bg-neutral-700 rounded-md h-10 text-2xl`}
                  />
                </div>
                <div className="flex flex-col gap-10">
                  <input
                    id="subject"
                    onChange={(e) => setSubject(e.target.value)}
                    value={subject}
                    type="text"
                    placeholder=" &#x261D; Subject"
                    className={`${
                      errMsg === "subject is required" && "bg-red-600"
                    } bg-neutral-700 rounded-md h-10 text-2xl`}
                  />
                </div>
                <div className="flex flex-col gap-10">
                  <textarea
                    id="message"
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                    type="text"
                    placeholder=" &#x270D; Write your message"
                    className={`${
                      errMsg === "message is required" && "bg-red-600"
                    } bg-neutral-700 rounded-md text-2xl`}
                    cols="30"
                    rows="10"
                  ></textarea>
                </div>
                <div className="flex flex-col items-center justify-center mt-5">
                  <p className="text-xl">Your lucky number &#x2660;</p>
                  <strong className="flex items-center justify-center rounded-md bg-dark text-blue-400 text-3xl font-Unkempt ">
                    {verNum}
                  </strong>
                </div>
                <div className="flex flex-col items-center justify-center">
                  <div>
                    <input
                      pr="4.5rem"
                      type="text"
                      color="gray.500B"
                      border={"solid"}
                      placeholder={placeholderVer}
                      value={inputMatch}
                      onChange={(e) => setInputMatch(e.target.value)}
                      className="rounded-md w-48 h-9 text-center text-blue-700 text-md"
                    />
                  </div>
                  <div className="flex flex-col py-1">
                    <button
                      colorScheme="blue"
                      border={"solid"}
                      color="white"
                      onClick={matchUp}
                      className="bg-blue-600 w-48 h-9 rounded-md"
                    >
                      enter
                    </button>
                  </div>
                </div>
                <div>
                  {isValidated && (
                    <button
                      className="w-full flex h-14 bg-slate-700 rounded-md text-2xl gap-2 text-center items-center justify-center"
                      onClick={handleSend}
                      type="submit"
                    >
                      Send
                      <span className=" text-3xl">
                        <RiMailSendLine />
                      </span>
                    </button>
                  )}
                </div>
              </form>
              {errMsg && (
                <div className="italic text-white py-4 border-solid border-red-600 border-4 rounded-lg">
                  <h2 className="underline text-3xl text-center">Attention!</h2>
                  <p className="text-2xl">{errMsg}.</p>
                </div>
              )}
              {successMsg && (
                <div className="italic text-white py-4 border-solid border-blue-600 border-4 rounded-lg">
                  <h2 className="text-3xl text-center">Horaayy!!!</h2>
                  <p className="text-2xl">{successMsg}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pageme;
